type EventListener = (...args: unknown[]) => void

class SimpleEventBus {
  private listeners = new Map<string, Set<EventListener>>()

  on(event: string, listener: EventListener) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)!.add(listener)
  }

  emit(event: string, ...args: unknown[]) {
    this.listeners.get(event)?.forEach(listener => listener(...args))
  }
}

const eventBus = new SimpleEventBus()

export default eventBus
